import type { ClientOptions, InferRpcClient } from "@redotech/rpc/client";
import { createRpcClient } from "@redotech/rpc/client";
import { rpcDefinition } from "./definition";

export function createRedoMarketingRpcClient(
  options: ClientOptions<typeof rpcDefinition>,
): InferRpcClient<typeof rpcDefinition> {
  return createRpcClient(rpcDefinition, options);
}

export type RedoMarketingRpcClient = ReturnType<
  typeof createRedoMarketingRpcClient
>;
